import React, { useState, useEffect } from 'react';
import './AddHeading2.css';

const AddHeading2 = () => {
  const [name, setName] = useState('');
  const [unit, setUnit] = useState('');
  const [characteristics, setCharacteristics] = useState([]);
  const [newCharacteristic, setNewCharacteristic] = useState('');
  const [makeInputs, setMakeInputs] = useState({});
  const [headingsList, setHeadingsList] = useState([]);
  const [editingHeading, setEditingHeading] = useState(null);
  const [openAccordion, setOpenAccordion] = useState(null); // ✅ Accordion state

  useEffect(() => {
    fetch('https://ideatorportal.in/api/list_fixed_heading.php')
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) setHeadingsList(data);
      })
      .catch(err => console.error('Error fetching headings:', err));
  }, []);

  const handleAddCharacteristic = () => {
    if (!newCharacteristic.trim()) return;
    setCharacteristics([...characteristics, {
      characteristic: newCharacteristic.trim(),
      makes: []
    }]);
    setNewCharacteristic('');
  };

  const handleDeleteCharacteristic = (index) => {
    const updated = [...characteristics];
    updated.splice(index, 1);
    setCharacteristics(updated);
  };

  const handleMakeChange = (index, field, value) => {
    setMakeInputs((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        [field]: value
      }
    }));
  };

  const handleAddMake = (index) => {
    const makeData = makeInputs[index];
    if (!makeData?.make_name || !makeData?.price_per_unit) return;

    const updated = [...characteristics];
    updated[index].makes.push({
      make_name: makeData.make_name.trim(),
      price_per_unit: parseFloat(makeData.price_per_unit)
    });

    setCharacteristics(updated);
    setMakeInputs((prev) => ({ ...prev, [index]: {} }));
  };

  const handleDeleteMake = (charIndex, makeIndex) => {
    const updated = [...characteristics];
    updated[charIndex].makes.splice(makeIndex, 1);
    setCharacteristics(updated);
  };

  const handleSubmit = async () => {
    if (!name.trim() || !unit.trim() || characteristics.length === 0) {
      alert('Missing required fields');
      return;
    }

    const payload = {
      name: name.trim(),
      unit: unit.trim(),
      characteristics
    };

    try {
      const response = await fetch('https://ideatorportal.in/api/add_fixed_heading.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const result = await response.json();
      if (result.success) {
        alert('Heading added successfully!');
        setName('');
        setUnit('');
        setCharacteristics([]);
        setMakeInputs({});
        window.location.reload();
      } else {
        alert(result.message || 'Failed to add heading');
      }
    } catch (error) {
      console.error('Error submitting heading:', error);
      alert('Submission failed!');
    }
  };

  const handleSaveEdit = async (edited) => {
    try {
      const response = await fetch('https://ideatorportal.in/api/edit_fixed_heading.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(edited)
      });

      const result = await response.json();
      if (result.success) {
        alert('Heading updated successfully!');
        setEditingHeading(null);
        window.location.reload();
      } else {
        alert(result.message || 'Update failed');
      }
    } catch (error) {
      console.error('Error updating heading:', error);
      alert('Update failed');
    }
  };

  return (
    <div className="add-heading-container">
      <h2>Add Fixed Price Heading</h2>
      <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Heading Name" />
      <input value={unit} onChange={(e) => setUnit(e.target.value)} placeholder="Unit" />

      <div className="char-input-section">
        <input
          value={newCharacteristic}
          onChange={(e) => setNewCharacteristic(e.target.value)}
          placeholder="Add Characteristic"
        />
        <button onClick={handleAddCharacteristic}>Add Characteristic</button>
      </div>

      {characteristics.map((char, index) => (
        <div key={index} className="char-block">
          <h4>
            {char.characteristic}
            <button onClick={() => handleDeleteCharacteristic(index)}>🗑️</button>
          </h4>

          <div className="make-form">
            <input
              value={makeInputs[index]?.make_name || ''}
              onChange={(e) => handleMakeChange(index, 'make_name', e.target.value)}
              placeholder="Make"
            />
            <input
              type="number"
              value={makeInputs[index]?.price_per_unit || ''}
              onChange={(e) => handleMakeChange(index, 'price_per_unit', e.target.value)}
              placeholder="Price"
            />
            <button onClick={() => handleAddMake(index)}>Add Make</button>
          </div>

          <ul>
            {char.makes.map((make, mIndex) => (
              <li key={mIndex}>
                {make.make_name} — ₹{make.price_per_unit}
                <button onClick={() => handleDeleteMake(index, mIndex)}>🗑️</button>
              </li>
            ))}
          </ul>
        </div>
      ))}

      <button onClick={handleSubmit}>Add Heading</button>

      <h3 style={{ marginTop: '40px', borderTop: '1px solid #ccc', paddingTop: '20px' }}>
        View Existing Fixed Headings
      </h3>

      {headingsList.length === 0 ? (
        <p>No headings found.</p>
      ) : (
        <div className="heading-list">
          {headingsList.map((heading, i) => (
            <div className="heading-card" key={i}>
              <h4
                className="accordion-header"
                onClick={() => setOpenAccordion(openAccordion === i ? null : i)}
              >
                {heading.name} <span className="unit-tag">({heading.unit})</span>
                <span className="accordion-icon">{openAccordion === i ? '▲' : '▼'}</span>
              </h4>

              {openAccordion === i && (
                <>
                  <button className="edit-button" onClick={() => setEditingHeading(heading)}>✏️ Edit</button>

                  {heading.characteristics.map((char, j) => (
                    <div key={j} className="char-block small">
                      <strong>{char.characteristic}</strong>
                      <ul>
                        {char.makes.map((make, k) => (
                          <li key={k}>
                            {make.make_name} — ₹{make.price_per_unit}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}

                  {editingHeading?.id === heading.id && (
                    <div className="edit-section">
                      <input
                        value={editingHeading.name}
                        onChange={(e) =>
                          setEditingHeading({ ...editingHeading, name: e.target.value })}
                        placeholder="Heading Name"
                      />
                      <input
                        value={editingHeading.unit}
                        onChange={(e) =>
                          setEditingHeading({ ...editingHeading, unit: e.target.value })}
                        placeholder="Unit"
                      />

                      {editingHeading.characteristics.map((char, cIdx) => (
                        <div key={cIdx} className="char-block small">
                          <input
                            value={char.characteristic}
                            onChange={(e) => {
                              const updated = [...editingHeading.characteristics];
                              updated[cIdx].characteristic = e.target.value;
                              setEditingHeading({ ...editingHeading, characteristics: updated });
                            }}
                            placeholder="Characteristic"
                          />

                          {char.makes.map((make, mIdx) => (
                            <div key={mIdx} className="make-edit-line">
                              <input
                                value={make.make_name}
                                onChange={(e) => {
                                  const updated = [...editingHeading.characteristics];
                                  updated[cIdx].makes[mIdx].make_name = e.target.value;
                                  setEditingHeading({ ...editingHeading, characteristics: updated });
                                }}
                                placeholder="Make Name"
                              />
                              <input
                                type="number"
                                value={make.price_per_unit}
                                onChange={(e) => {
                                  const updated = [...editingHeading.characteristics];
                                  updated[cIdx].makes[mIdx].price_per_unit = parseFloat(e.target.value);
                                  setEditingHeading({ ...editingHeading, characteristics: updated });
                                }}
                                placeholder="Price"
                              />
                            </div>
                          ))}

                          {/* ➕ Add new make */}
                          <div className="make-edit-line">
                            <input
                              placeholder="New Make Name"
                              value={char.newMakeName || ''}
                              onChange={(e) => {
                                const updated = [...editingHeading.characteristics];
                                updated[cIdx].newMakeName = e.target.value;
                                setEditingHeading({ ...editingHeading, characteristics: updated });
                              }}
                            />
                            <input
                              type="number"
                              placeholder="New Price"
                              value={char.newPrice || ''}
                              onChange={(e) => {
                                const updated = [...editingHeading.characteristics];
                                updated[cIdx].newPrice = e.target.value;
                                setEditingHeading({ ...editingHeading, characteristics: updated });
                              }}
                            />
                            <button
                              onClick={() => {
                                const updated = [...editingHeading.characteristics];
                                if (char.newMakeName && char.newPrice) {
                                  updated[cIdx].makes.push({
                                    make_name: char.newMakeName,
                                    price_per_unit: parseFloat(char.newPrice),
                                  });
                                  updated[cIdx].newMakeName = '';
                                  updated[cIdx].newPrice = '';
                                  setEditingHeading({ ...editingHeading, characteristics: updated });
                                }
                              }}
                            >
                              ➕ Add Make
                            </button>
                          </div>
                        </div>
                      ))}

                      {/* ➕ Add new characteristic */}
                      <div className="char-block small">
                        <input
                          placeholder="New Characteristic"
                          value={editingHeading.newCharacteristicName || ''}
                          onChange={(e) =>
                            setEditingHeading({ ...editingHeading, newCharacteristicName: e.target.value })}
                        />
                        <button
                          onClick={() => {
                            if (editingHeading.newCharacteristicName) {
                              const newChar = {
                                characteristic: editingHeading.newCharacteristicName,
                                makes: [],
                              };
                              const updated = [...editingHeading.characteristics, newChar];
                              setEditingHeading({
                                ...editingHeading,
                                characteristics: updated,
                                newCharacteristicName: '',
                              });
                            }
                          }}
                        >
                          ➕ Add Characteristic
                        </button>
                      </div>

                      <div className="edit-actions">
                        <button onClick={() => handleSaveEdit(editingHeading)}>💾 Save</button>
                        <button onClick={() => setEditingHeading(null)}>❌ Cancel</button>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AddHeading2;
